import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CreditIncreaseService } from '../credit-increase.service';
import { CookieService } from 'ngx-cookie-service';

import {
  ReactiveFormsModule,
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ContentfulService } from '../contentful.service';
import { transformContentfulData } from '../contentful-transform.util';
import { runInThisContext } from 'node:vm';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  verifyForm: FormGroup = new FormGroup({
    lastFourDigits: new FormControl(''),
  });
  submitted = false;
  showError = false;
  page_content: any;
  contentfulData: any;
  subtitle: any;
  constructor(
    readonly route: ActivatedRoute,
    readonly creditIncreaseService: CreditIncreaseService,
    readonly formBuilder: FormBuilder,
    readonly navigationRouter: Router,
    readonly cookieService: CookieService,
    readonly contentfulService: ContentfulService
  ) {
    this.verifyForm = this.formBuilder.group({
      lastFourDigits: ['', [Validators.required, Validators.minLength(4)]],
    });
  }

  errorFunction() {
    if (this.verifyForm.invalid) {
      return;
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.verifyForm.controls;
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnInit() {
    this.creditIncreaseService.enLanguage.subscribe((res: any) => {
      this.getContentfulData(res ? 'en' : 'fr');
    });
    const accountNumber = this.cookieService.get('accountNumber');
    const hasAccountNumber = accountNumber !== '' && accountNumber !== 'undefined';

    if (hasAccountNumber) {
      this.creditIncreaseService.currentUserData.accountId =
        accountNumber;
      this.creditIncreaseService
        .getCliPostCall(accountNumber)
        .subscribe({
          next: (res: any) => {
            if (res.statusCode == '200') {
              this.creditIncreaseService.currentUserData.accountId =
                accountNumber;
            } else if (res.statusCode == '406') {
              this.creditIncreaseService.currentUserData.errorPageCode =
                res.statusCode;
              this.navigationRouter.navigate(['/error'],{ skipLocationChange: true });
            } else if (res.statusCode == '405') {
              this.creditIncreaseService.currentUserData.errorPageCode =
                res.statusCode;
              this.navigationRouter.navigate(['/error-data'],{ skipLocationChange: true });
            } else {
              this.navigationRouter.navigate(['/error'],{ skipLocationChange: true });
            }
          },
          error: () => {
            this.navigationRouter.navigate(['/error-data'],{ skipLocationChange: true });
          },
        });
    } else {
      this.navigationRouter.navigate(['/error-data'],{ skipLocationChange: true });
    }
  }
  onSubmit(): void {
    this.submitted = true;

    if (this.verifyForm.invalid) {
      return;
    }
    if (this.verifyForm.valid) {
      this.creditIncreaseService.currentUserData.PromoName = 'cli';

      let obj = {
        AccountId: this.creditIncreaseService.currentUserData.accountId,
        last_four_digits: this.verifyForm.value.lastFourDigits,
        PromoName: 'cli',
      };
      this.creditIncreaseService.validateLastFour(obj).subscribe((res: any) => {
        if (res?.statusCode == '200') {
          this.creditIncreaseService.currentUserData.lastFourDigits =
            this.verifyForm.value.lastFourDigits;
          this.creditIncreaseService.currentUserData.currentCreditLimit =
            res.current_credit_limit;
          this.creditIncreaseService.currentUserData.offeredCreditLimit =
            res.offered_credit_limit;
            this.creditIncreaseService.currentUserData.PromoToken =
            res.PromoToken;
            
         
          this.navigationRouter.navigate(['/creditIncrease'],{ skipLocationChange: true });
        }
        if (res?.statusCode == '406') {
          this.navigationRouter.navigate(['/error'],{ skipLocationChange: true });
        }
        if (res?.statusCode == '405') {
          this.navigationRouter.navigate(['/error-data'],{ skipLocationChange: true });
        }
        if (res?.statusCode == '407') {
          this.showError = true;
        }
      });
    }
  }
  getContentfulData(currentLang: any) {
    this.contentfulService
      .getEntry(currentLang, 'page', {
        'fields.slug': '/credit_limit_increase',
        include: 10,
      })
      .then((res) => {
        this.page_content = res;
        this.contentfulData = transformContentfulData(this.page_content?.content);
        this.subtitle = documentToHtmlString(this.page_content?.subtitle);
      });
  }

  tranformData(components: any[]) {
    return transformContentfulData(components);
  }
}
